import { fetchExtraProductInfo } from "./fetch-extra-product-info.js";
import { BRAND_NAME } from "./meta.js";
import {productAddData} from "./product-add-data";

export function createDetailPageProductAdd(items) {
    return fetchExtraProductInfo(items.map(item => item.id))
      .then((itemExtraInfo) => {
          return itemExtraInfo.reduce((accumulator, extraInfo) => {
              return accumulator.set(extraInfo.elementXmlId, extraInfo);
          }, new Map())
      })
      .then((/** Map<string, ProductExtraInfo> */itemExtraInfoMap) => {
          return items.map((item) => ({
              ...item,
              'brand': BRAND_NAME,
              'category': itemExtraInfoMap.get(item.id).elementSectionPath,
              'categoryId': itemExtraInfoMap.get(item.id).elementSectionId,
          }));
      })
      .then((products) => productAddData(products))
}
